import { AuthGuard } from "../../auth/helpers";
import { ProvidersListComponent } from "./pages/providers-list/providers-list.component";
import { ProvidersCreateComponent } from "./pages/providers-create/providers-create.component";
import { ProvidersEditComponent } from "./pages/providers-edit/providers-edit.component";
import { ProvidersDetailComponent } from "./pages/providers-detail/providers-detail.component";
import { IRoute } from "app/auth/models/utils-interfaces";

const providersRoutes: IRoute[] = [
  {
    path: "dashboard/providers/list",
    component: ProvidersListComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "dashboard/providers/create",
    component: ProvidersCreateComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "dashboard/providers/edit/:id",
    component: ProvidersEditComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "dashboard/provider/:id",
    component: ProvidersDetailComponent,
    canActivate: [AuthGuard],
  },
];
export default providersRoutes;
